import classNames from 'classnames'
import { FC } from 'react'
import styles from './charts.module.scss'

interface DashMeterProps {
  className?: string
  color: string
  count: number
  of: number
}

// "3 of 4 models" as four dashes, three of them filled.
export const DashMeter: FC<DashMeterProps> = ({
  className,
  color,
  count,
  of,
}) => (
  <span className={classNames(styles.dashMeter, className)}>
    {Array.from({ length: Math.max(of, 0) }, (_, index) => (
      <span
        className={styles.dash}
        key={index}
        style={index < count ? { background: color } : undefined}
      />
    ))}
  </span>
)
